// src/components/Teams/MemberCard.js
import React from "react";
import { Card, CardContent, Button, Box } from "@mui/material";
import UserInfo from "./UserInfo"; // Ensure that UserInfo.js is in the same folder

const MemberCard = ({ uid, pending, isCreator, onAccept, onReject, onRemove }) => (
  <Card variant="outlined" sx={{ mb: 1, p: 1 }}>
    <CardContent sx={{ p: 1, "&:last-child": { pb: 1 } }}>
      <UserInfo uid={uid} isCreator={isCreator} />
      <Box sx={{ mt: 1, display: "flex", gap: 1 }}>
        {pending ? (
          <>
            <Button variant="contained" color="success" size="small" onClick={onAccept}>
              Accept
            </Button>
            <Button variant="contained" color="error" size="small" onClick={onReject}>
              Reject
            </Button>
          </>
        ) : (
          !isCreator && onRemove && (
            <Button variant="outlined" color="error" size="small" onClick={onRemove}>
              Remove
            </Button>
          )
        )}
      </Box>
    </CardContent>
  </Card>
);

export default MemberCard;